module.exports = __webpack_public_path__ + "img/冷冻机系统的节能优化系统.7a93fd61.png";